import { useState } from "react";
import { Table } from "react-bootstrap";
import { useDispatch } from "react-redux";

import SimpleModal from "../../../components/common/SimpleModal";
import StaffForm from "./form/StaffForm";
import { setUpdateStaff } from "../../management/redux/managementSlice";

const StaffTable = ({ data }) => {
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const handleCloseModal = () => setShowModal(false);

  const handleEdit = (data) => {
    setShowModal(true);
    dispatch(setUpdateStaff(data));
  };

  return (
    <>
      <SimpleModal
        show={showModal}
        handleClose={handleCloseModal}
        title="ແກ້ໄຂຂໍ້ມູນພະນັກງານ"
      >
        <StaffForm handleClose={handleCloseModal} />
      </SimpleModal>

      <Table bordered>
        <thead>
          <tr>
            <th className="text-center">
              <strong>#</strong>
            </th>
            <th className="text-center">
              <strong>ລະຫັດພະນັກງານ</strong>
            </th>
            <th className="text-center">
              <strong>ຊື່ພະນັກງານ</strong>
            </th>
            <th className="text-center">
              <strong>ແກ້ໄຂ</strong>
            </th>
          </tr>
        </thead>
        <tbody>
          {data?.map((d, i) => {
            return (
              <tr key={d.id}>
                <td className="text-center">
                  <strong>{i + 1}</strong>
                </td>
                <td className="text-center">{d.staffId}</td>
                <td className="text-center">{d.fullname}</td>
                <td className="text-center">
                  <div
                    className="btn btn-primary shadow btn-xs sharp me-1"
                    onClick={() => handleEdit(d)}
                  >
                    <i className="fas fa-pencil-alt"></i>
                  </div>
                </td>
              </tr>
            );
          })}
        </tbody>
      </Table>
    </>
  );
};

export default StaffTable;
